import React from 'react'
import SGRCSData from '../../../Assets/JSON/Student_life/SGRCJson/sgrc.json'
import DocumentViewer from '../../../Component/DynamicDocViewer/Doc_Viewer'

const RandDDocview = () => {
  return (
    <div>
      <DocumentViewer navigateTo={'/'} selectedDocData={SGRCSData} />
    </div>
  )
}

export default RandDDocview
